module.exports = __webpack_public_path__ + "fonts/montserrat-black-webfont.51cbc79.woff2";